import { createTheme} from '@mui/material';
export const requiredColorCode = '#d32f2f';
export const PropsReactCodeInput = {
    inputStyle: {
        width: '60px',
        height: '80px',
        borderRadius: '8px',
        fontSize: '24px',
        padding: '0px 16px',
        margin:'16px',
        background: '#FFFFFF',
        webkitAppearance: 'none',
        MozAppearance: 'none',
        border: '1px solid #9D9E9F',
        //boxShadow: '0px 0px 7px #9D9E9F',
        cursor: 'default',
        '&:active': {
            backgroundColor: '#214DCE !important',
            //boxShadow: '0px 0px 7px #214DCE',
            border: '1px solid #214DCE !important',
        },
        '&:hover': {
            backgroundColor: '#214DCE !important',
            //boxShadow: '0px 0px 7px #214DCE',
            border: '1px solid #214DCE !important',
        },
        '&:focus': {
            backgroundColor: '#214DCE !important',
            //boxShadow: '0px 0px 7px #214DCE',
            border: '1px solid #214DCE !important',
        },
    }
};

export const PropsReactCodeInputMobile = {
    inputStyle: {
        // fontFamily: 'monospace',
        // margin: '4px',
        width: '45px',
        height: '80px',
        borderRadius: '8px',
        fontSize: '24px',
        padding: '0px 16px',
        margin:'16px',
        background: '#FFFFFF',
        webkitAppearance: 'none',
        MozAppearance: 'none',
        border: '1px solid #9D9E9F',
        //boxShadow: '0px 0px 7px #9D9E9F',
        cursor: 'default',
        '&:active': {
            backgroundColor: '#214DCE !important',
            //boxShadow: '0px 0px 7px #214DCE',
            border: '1px solid #214DCE !important',
        },
        '&:hover': {
            backgroundColor: '#214DCE !important',
            //boxShadow: '0px 0px 7px #214DCE',
            border: '1px solid #214DCE !important',
        },
        '&:focus': {
            backgroundColor: '#214DCE !important',
            //boxShadow: '0px 0px 7px #214DCE',
            border: '1px solid #214DCE !important',
        },
    }
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export const FieldComponentFont = createTheme({
    typography: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '16px',
        letterSpacing: '-0.0044em',
        color:'rgba(0, 0, 0, 0.39)',
    },
    error: {
        '&.MuiFormHelperText-root.Mui-error': {
            color: 'black'
        }
    }
});

//export const FieldComponentFontTest = createTheme({
//    typography: {
//        fontFamily: 'Lato',
//        fontStyle: 'normal',
//        fontWeight: '400',
//        fontSize: '16px',
//        letterSpacing: '-0.0044em',
//        color:'rgba(0, 0, 0, 0.39)',
//    },
//    MuiPaper: {
//        root: {
//            '&.MuiMenu-paper': {
//                '&.MuiPopover-paper': {
//                    marginLeft:'-300px',
//                },
//            },
//        },
//    },
//});

export const SelectedButtonLink={
    height: '40px',
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '20px',
    display: 'flex',
    textTransform: 'none',
    alignItems: 'center',
    color: '#214DCE',
};

export const NotselectedButtonLink={
    height: '40px',
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '20px',
    display: 'flex',
    textTransform: 'none',
    alignItems: 'center',
    color: '#272D3C',
};

//export const FieldComponentFont2 = createTheme({
//    typography: {
//        fontFamily: 'Lato',
//        fontStyle: 'normal',
//        fontWeight: '400',
//        fontSize: '16px',
//        //lineHeight: '24px',
//        letterSpacing: '-0.0044em',
//        color: '#272D3C',
//    }
//});

//export const CustomizedAccordion =createTheme({
//    Accordion: {
//        '& .MuiPaper-root-MuiAccordion-root': {

//            borderRadius: '10px',
//            boxShadow: 'none'
//        },
//        padding: '16px',
//        boxShadow: 'none'
//    }
//});

export const FontLinkNavBar = createTheme({
    typography: {
        poster: {
            fontSize: '17px',
        },
        // Disable h3 variant
        h3: undefined,
    },
});

//const theme = createMuiTheme({
//    //v5.0.0
//    typography: {
//      body2: {
//          fontSize: [16, "!important"]
//      }
//    },
//    //older versions
//    overrides: {
//      MuiTypography: {
//        body2: {
//          fontSize: [16, "!important"]
//        }
//      }
//    }
//  });

export const MenuProps2 = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 270,
        },
    },
};

export const bdc ={
    FileFrame0Bdc:{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexDirection: 'row',
        width: '800px',
        ////padding:'10px',
        paddingLeft: '10px',
        paddingRight: '10px',

    },
    logo: {
        display: 'flex',
        width: '146.83px',
        paddingLeft: '20px',
        paddingTop: '20px',
        //height: '40px',
        flex: 'none',
        order: '0',
        flexGrow: '0',

    },
    FileFrame1Bdc:{
        display: 'flex',
        //alignItems: 'flex-start',
        gap:'16px',
        flexDirection: 'column',
        //width: '800px',
        flex: 'none',
        order: '1',
        flexGrow: '0',

    },
    FileFrame2Bdc:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'700',
        fontSize:'34px',
        //lineHeight:'44px',

        display:'flex',
        alignItems:'flex-end',
        //textAlign:'center',
        letterSpacing:'-0.75px',

        color:'#272D3C',

        flex:'none',
        order:'0',
        flexGrow:'0',
    },
    FileFrame3Bdc:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-end',
        padding:'0px',

        //width:'380px',
        //height:'32px',

        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    FileFrame31321Bdc:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        padding:'0px',

        //width:'380px',
        //height:'32px',

        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    FileFrame4Bdc:{
        //width:'248px',
        //height:'16px',

        /* Body/B2 */

        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'900',
        fontSize:'15px',
        margin:0,
        //lineHeight:'16px',
        /* identical to box height, or 114% */

        display:'flex',
        alignItems:'center',
        textAlign:'center',
        letterSpacing:'-0.0044em',

        /* Text/Secondary */

        color:'#475063',

        /* Inside auto layout */

        flex:'none',
        order:'0',
        flexGrow:'0',
    },
    FileFrame5Bdc:{
        //width:'248px',
        //height:'16px',

        /* Body/B2 */

        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'900',
        fontSize:'15px',
        //lineHeight:'16px',
        /* identical to box height, or 114% */

        display:'flex',
        alignItems:'center',
        textAlign:'center',
        letterSpacing:'-0.0044em',

        /* Text/Secondary */

        color:'#475063',

        /* Inside auto layout */

        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    FileFrame6Bdc:{
        display: 'flex',
        //alignItems: 'flex-start',
        //gap:'16px',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexDirection: 'row',
        width: '800px',
        paddingLeft: '10px',
        paddingRight: '10px',
    },
    FileFrame7Bdc:{
        display: 'flex',
        //gap:'24px',
        alignItems: 'flex-start',
        //justifyContent: 'space-between',
        flexDirection: 'column',
        //width: '800px',
        flex: 'none',
        order: '0',
        flexGrow: '0',

    },
    FileFrame8Bdc:{
        fontFamily: 'Lato',
        fontStyle:'normal',
        fontWeight:'600',
        fontSize:'20px',
        //lineHeight:'32px',
        display:'flex',
        alignItems:'center',
        letterSpacing:'-0.15px',
        color:'rgb(33, 77, 206)',
    },
    FileFrame9Bdc:{
        display: 'flex',
        //gap:'16px',
        //alignItems: 'flex-start',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        //width: '800px',
        //flex: 'none',
        //order: '0',
        //flexGrow: '0',
    },
    FileFrame10Bdc:{
        display: 'flex',
        flexDirection: 'row',
    },
    FileFrame11Bdc:{
        //lineHeight: '2.2em',
        fontFamily: 'Lato',
        fontStyle: 'normal',
        // width: '800px',
        margin:0,
        letterSpacing: '-0.8px',
    },

    FileFrame12Bdc:{
        display: 'flex',
        //gap:'24px',
        alignItems: 'flex-start',
        //justifyContent: 'space-between',
        flexDirection: 'column',
        //width: '800px',
        flex: 'none',
        order: '1',
        flexGrow: '0',
    },
    FileFrame13Bdc:{
        display: 'flex',
        //alignItems: 'flex-start',
        //gap:'16px',
        alignItems: 'flex-start',
        //justifyContent: 'space-between',
        flexDirection: 'column',
        width: '800px',
        gap:'16px',
        padding: '10px',
    },
    FileFrame17Bdc:{
        display: 'flex',
        //alignItems: 'flex-start',
        //gap:'16px',
        alignItems: 'flex-start',
        //justifyContent: 'space-between',
        flexDirection: 'column',
        width: '800px',
        gap:'24px',
    },
    FileFrame14Bdc:{
        display: 'flex',

        //gap:'16px',
        //alignItems: 'flex-start',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        alignItems: 'flex-end',
        gap: '7px',
        width: '780px',

    },
    FileFrame15Bdc:{
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        width: '800px',
        //gap:'24px',
        padding: '10px',

    },
    FileFrame16Bdc:{
        display: 'flex',
        //alignItems: 'flex-start',
        //gap:'16px',
        alignItems: 'flex-start',
        //justifyContent: 'space-between',
        flexDirection: 'column',
        width: '800px',
        //gap:'24px',
        padding: '10px',
    },
    FileFrame18Bdc:{
        fontFamily:'Lato',
        //fontStyle:'normal',
        // fontWeight:'900',
        // fontSize:'14px',
        margin:0,
        letterSpacing:'-0.8px',
    },
    FileFrame18818Bdc:{
        fontFamily:'Lato',
        margin:0,
        letterSpacing:'-0.8px',
    },
    FileFrame19Bdc:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-end',
        paddingRight: '10px',
        paddingTop: '50px',
        justifyContent: 'flex-end',
        fontFamily:'Lato',
        fontStyle:'normal',
        fontSize:'15px',
        letterSpacing:'-0.8px',

    }

};
export const ordreMissionStyles = {
    page: {
        display: 'flex',
        gap:'16px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',

    },
    logo: {
        display: 'flex',
        width: '146.83px',
        //paddingLeft: '20px',
        paddingTop: '20px',
        //height: '40px',
        flex: 'none',
        order: '0',
        flexGrow: '0',

    },
    logo54321: {
        display: 'flex',
        width: '146.83px',
        //paddingLeft: '20px',
        paddingTop: '13px',
        //height: '40px',
        flex: 'none',
        order: '0',
        flexGrow: '0',

    },
    FileFrame1Box1AppWidth:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flex-start',
        justifyContent:'space-between',
        alignSelf:'stretch',
        gap:'8px',
        width: '855px',
        //alignSelf:'stretch',

        /* Inside auto layout */

        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    FileFrame1Box1AppWidth123:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flex-start',
        justifyContent:'space-between',
        alignSelf:'stretch',
        gap:'8px',
        width: '855px',
        marginTop:'10px',
        //alignSelf:'stretch',

        /* Inside auto layout */

        flex:'none',
        order:'1',
        flexGrow:'0',
    },

    FileFrame1Box15467:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flex-start',
        justifyContent:'space-between',
        alignSelf:'stretch',
        //paddingLeft:'20px',
        gap:'8px',
        flex:'none',
        marginTop:'-13px',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileTitles2AppWidth:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        //paddingTop:'60px',
        //width:'420px',

        flex:'none',
        order:'0',
        flexGrow:'0',
    },
    OrdreMissionFileTitles2:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        paddingTop:'15px',
        alignSelf:'stretch',
        //width:'420px',

        flex:'none',
        order:'0',
        flexGrow:'0',
    },
    FieldsRow1:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flex-start',
        //width:'420px',

        flex:'none',
        order:'0',
        flexGrow:'0',
    },
    FieldsOrdreMissionFile:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'600',
        fontSize:'20px',
        ////lineHeight:'12px',
        //width:'250px',
        display:'flex',
        margin:'0px',
        letterSpacing:'-0.8px',

        color:'#475063',
        order:'0',
        flexGrow:'0',

    },
    FieldsOrdreMissionFileContent:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'600',
        fontSize:'20px',
        ////lineHeight:'12px',
        /* identical to box height, or 150% */
        //width:'250px',
        display:'flex',
        margin:'0px',
        //letterSpacing:'-0.8em',
        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    FieldsRow2:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flex-start',
        //width:'420px',

        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    FieldsRow3:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flex-start',
        //width:'420px',

        flex:'none',
        order:'2',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3F4:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flex-start',
        //width:'420px',
        /* Inside auto layout */

        flex:'none',
        order:'3',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3F5:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flex-start',

        //width:'420px',
        /* Inside auto layout */

        flex:'none',
        order:'4',
        flexGrow:'0',
    },
    OrdreMissionFileTitlesAppWidth:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        padding:'0px',
        gap:'8px',

        width:'380px',
        //height:'84px',

        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileTitles:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        padding:'0px',
        gap:'8px',

        flex:'none',
        order:'1',
        flexGrow:'0',

    },
    OrdreMissionFileTitle1AppWidth:{
        width:'380px',
        height:'44px',

        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'700',
        fontSize:'34px',
        //lineHeight:'44px',

        display:'flex',
        alignItems:'center',
        textAlign:'center',
        letterSpacing:'-0.75px',

        color:'#272D3C',

        flex:'none',
        order:'0',
        flexGrow:'0',
    },
    OrdreMissionFileTitle1:{

        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'700',
        fontSize:'34px',
        //lineHeight:'44px',

        display:'flex',
        alignItems:'center',
        textAlign:'center',
        letterSpacing:'-0.75px',

        color:'#272D3C',

        flex:'none',
        order:'0',
        flexGrow:'0',
    },
    OrdreMissionFileSousTitlesAppWidth:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        padding:'0px',

        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileSousTitles:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-end',
        padding:'0px',

        width:'248px',
        height:'32px',

        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileSousTitle2:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'14px',
        display:'flex',
        letterSpacing:'-0.0044em',
        color:'#475063',
        margin:0,
        flex:'none',
        order:'0',
        flexGrow:'0',
    },
    OrdreMissionFileSousTitle11111:{
        //width:'175px',
        height:'16px',

        /* Body/B2 */

        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'14px',
        //lineHeight:'16px',
        /* identical to box height, or 114% */

        display:'flex',
        alignItems:'center',
        textAlign:'center',
        letterSpacing:'-0.0044em',

        /* Text/Secondary */

        color:'#475063',

        /* Inside auto layout */

        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileSousTitle1:{

        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'14px',
        margin:0,
        display:'flex',
        letterSpacing:'-0.0044em',
        color:'#475063',
        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flexStart',
        //padding:'10px',
        gap:'4px',
        //lineHeight:'8px',
        alignSelf:'stretch',
        width: '855px',
        //alignSelf:'stretch',
        order:'3',
        flexGrow:'0',
    },
    OrdreMissionFileFrame2:{
        display:'flex',
        fontFamily:'Lato',
        fontStyle:'normal',
        alignItems:'flexStart',
        alignSelf:'stretch',
        flex:'none',
        marginLeft:'10px',
        color:'rgba(33, 77, 206, 1)',
        order:'0',
        flexGrow:'0',
    },
    OrdreMissionFileFrame32:{
        display:'flex',
        flexDirection:'column',
        alignItems:'flexStart',
        padding:'10px',
        //marginTop:'30px',
        alignSelf:'stretch',
        border:'1px solid black',
        order:'1',
        flexGrow:'0',

    },
    OrdreMissionFileFrame3F1Prime:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',
        width:'40%',
    },
    OrdreMissionFile232323:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        //lineHeight:'20px',

        display:'flex',
        alignItems:'flexStart',
        letterSpacing:'-0.0044em',

        color:'black',

        flex:'none',
        order:'0',
        flexGrow:'0',
        width:'36%',
    },
    OrdreMissionFile2323234:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        //lineHeight:'20px',

        display:'flex',
        alignItems:'flexStart',
        letterSpacing:'-0.0044em',

        color:'black',

        flex:'none',
        order:'0',
        flexGrow:'0',
        width:'39%',
    },
    OrdreMissionFileFrame3F1:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',
        alignSelf:'stretch',
        width:'50%',
        flex:'none',
        order:'0',
        flexGrow:'0',
    },
    AppLineH:{
        //width:'50%',
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        display:'flex',
        alignItems:'flexStart',
        letterSpacing:'-0.0044em',
        marginBottom:'4px',

        color:'black',

        flex:'none',
        order:'0',
        flexGrow:'0',
        //lineHeight:'20px',
    },
    OrdreMissionFileFrame3F1IntitulePrimeAppLine:{
        width:'100px',
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        //lineHeight:'20px',

        display:'flex',
        alignItems:'flexStart',
        letterSpacing:'-0.0044em',

        color:'black',

        flex:'none',
        order:'0',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3F1IntitulePrime:{
        //width:'100px',
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        marginBottom:'4px',

        display:'flex',
        alignItems:'flexStart',
        letterSpacing:'-0.0044em',

        color:'black',

        flex:'none',
        order:'0',
        flexGrow:'0',
    },

    OrdreMissionFileFrame3F1Intitule:{
        width:'20%',
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        marginBottom:'4px',
        fontSize:'16px',

        display:'flex',
        alignItems:'flexStart',
        letterSpacing:'-0.0044em',

        color:'black',

        flex:'none',
        order:'0',
        flexGrow:'0',

    },
    OrdreMissionFileFrame223F1Intitule:{
        width:'24%',
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        marginBottom:'4px',
        fontSize:'16px',

        display:'flex',
        alignItems:'flexStart',
        letterSpacing:'-0.0044em',

        color:'black',

        flex:'none',
        order:'0',
        flexGrow:'0',

    },
    OrdreMissionFileFrame3F1IntituleTwo:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        display:'flex',
        alignItems:'flexStart',
        letterSpacing:'-0.0044em',
        marginBottom:'4px',
        color:'black',

        flex:'none',
        order:'0',
        flexGrow:'0',

    },
    OrdreMissionFileFrame3F1IntituleMiss:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        display:'inline',
        alignItems:'flexStart',
        letterSpacing:'-0.0044em',
        color:'black',
        marginBottom:'4px',

    },
    OrdreMissionFileFrame3F1ContentLieu:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        //lineHeight:'20px',
        //width:'250px',
        marginBottom:'4px',
        display:'flex',
        ////lineHeight:'20px',
        letterSpacing:'-0.0044em',
        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionF121212:{
        width:'9%',
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        //lineHeight:'20px',
        //width:'250px',
        display:'flex',
        marginBottom:'4px',
        ////lineHeight:'20px',
        letterSpacing:'-0.0044em',
        flex:'none',
        order:'0',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3F1ContentPrime:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'150',
        fontSize:'16px',
        marginBottom:'4px',
        //width:'166px',
        display:'flex',
        ////lineHeight:'20px',
        letterSpacing:'-0.0044em',
        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3F1ContentFraisDep:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',

        width:'500px',
        display:'flex',
        ////lineHeight:'20px',
        letterSpacing:'-0.0044em',
        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3F1Content:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        marginBottom:'4px',
        //width:'250px',
        display:'flex',
        ////lineHeight:'20px',
        letterSpacing:'-0.0044em',
        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3F1Content33:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        width:'64%',
        //width:'250px',
        display:'flex',
        ////lineHeight:'20px',
        letterSpacing:'-0.0044em',
        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3F1Content4:{
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        width:'61%',
        //width:'250px',
        display:'flex',
        ////lineHeight:'20px',
        letterSpacing:'-0.0044em',
        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3F2:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',
        alignSelf:'stretch',
        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3F6:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',
        alignSelf:'stretch',
    },

    OrdreMissionFileFrame4:{
        display:'flex',
        alignItems:'flexStart',
        flexDirection:'column',
        flex:'none',
        //padding:'10px',
        gap:'4px',
        alignSelf:'stretch',
        width: '855px',
        //lineHeight:'8px',
        //alignSelf:'stretch',
        //marginTop:'30px',

        order:'4',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3Row7:{
        display:'flex',
        //lineHeight:'20px',
        flexDirection:'row',
        alignItems:'flexStart',

        alignSelf:'stretch',
        /* Inside auto layout */
        ////lineHeight:'10px',
        flex:'none',
        order:'2',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3Row8:{
        display:'flex',
        //lineHeight:'20px',
        flexDirection:'row',
        alignItems:'flexStart',

        alignSelf:'stretch',
        /* Inside auto layout */
        ////lineHeight:'10px',
        flex:'none',
        order:'3',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3Row9:{
        display:'flex',
        //lineHeight:'20px',
        flexDirection:'row',
        alignItems:'flexStart',

        alignSelf:'stretch',
        /* Inside auto layout */
        ////lineHeight:'10px',
        flex:'none',
        order:'3',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3F3:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',

        alignSelf:'stretch',
        /* Inside auto layout */
        ////lineHeight:'10px',
        flex:'none',
        order:'2',
        flexGrow:'0',
    },

    OrdreMissionFileFrame5:{
        display:'flex',
        alignItems:'flexStart',
        flexDirection:'column',
        flex:'none',
        //padding:'10px',
        gap:'4px',
        alignSelf:'stretch',
        width: '855px',
        //lineHeight:'8px',
        //alignSelf:'stretch',
        //marginTop:'30px',

        order:'5',
        flexGrow:'0',
    },

    OrdreMissionFileFrame3Row1:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',
        alignSelf:'stretch',
        flex:'none',
        order:'0',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3F111:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',
        width:'20%'
    },
    OrdreMissionFileFrame3F11Prime:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',
        width:'33%',
    },
    OrdreMissionFileFrame3F11PrimeEmail:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',
        width:'40%',
    },
    OrdreMissionFileFrame3F11:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',
        width:'50%',
        //width:'420px',
        //marginTop:'10px',
        /* Inside auto layout */

        flex:'none',
        order:'1',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3Row2:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',

        alignSelf:'stretch',
        /* Inside auto layout */

        flex:'none',
        order:'1',
        flexGrow:'0',
    },

    OrdreMissionFileFrame3Row3:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',

        alignSelf:'stretch',
        /* Inside auto layout */

        flex:'none',
        order:'2',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3Row4:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',

        alignSelf:'stretch',
        /* Inside auto layout */

        flex:'none',
        order:'3',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3Row5:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',
        alignSelf:'stretch',
        //alignSelf:'stretch',
        /* Inside auto layout */

        flex:'none',
        order:'4',
        flexGrow:'0',
    },
    OrdreMissionFileFrame3Row6:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flexStart',

        alignSelf:'stretch',
        /* Inside auto layout */

        flex:'none',
        order:'5',
        flexGrow:'0',
    },

    OrdreMissionFileFrame6:{
        display:'flex',
        alignItems:'flexStart',
        flexDirection:'column',
        flex:'none',
        //padding:'10px',
        width: '855px',
        gap:'4px',
        alignSelf:'stretch',
        //lineHeight:'8px',
        //alignSelf:'stretch',
        //marginTop:'30px',

        order:'6',
        flexGrow:'0',
    },

    ListStyle:{
        listStyleType:'disc',
        fontFamily:'Lato',
        fontStyle:'normal',
        fontWeight:'400',
        fontSize:'16px',
        //lineHeight:'24px',
    },

    OrdreMissionFileFrame7:{
        display:'flex',
        alignItems:'flexStart',
        flexDirection:'column',
        flex:'none',
        //padding:'10px',
        gap:'4px',
        width: '855px',
        alignSelf:'stretch',
        //alignSelf:'stretch',
        //marginTop:'30px',

        order:'7',
        flexGrow:'0',
    },
    OrdreMissionFileFrame8:{
        display:'flex',
        alignItems:'flexStart',
        flexDirection:'column',
        flex:'none',
        //padding:'10px',
        gap:'4px',
        alignSelf:'stretch',
        width: '855px',

        order:'8',
        flexGrow:'0',
    },
    OrdreMissionFileFrame9:{
        display:'flex',
        alignItems:'flexStart',
        flexDirection:'column',
        flex:'none',
        //padding:'10px',
        gap:'4px',
        alignSelf:'stretch',
        //alignSelf:'stretch',
        //width: '855px',
        //marginTop:'30px',

        order:'9',
        flexGrow:'0',
    },

    OrdreMissionFileFrame10:{
        display: 'flex',
        alignItems: 'flex-start',
        flex: 'none',
        color:'rgba(33, 77, 206, 1)',
        order: '11',
        padding:'13px',
        alignSelf:'stretch',
        marginTop:'20px',
        width: '855px',
        flexGrow: '0',
    },
};
export const SideBarNavigationFicheExpert = {
    frame1SideBarCompteExpert:{
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '16px',
        gap: '4px',
        width: 'fit-content',
        height: 'fit-content',
        background: '#FFFFFF',
        border: '1px solid #7083DD',
        borderRadius: '10px',
    },
    selectedTitle:{
        background: '#E7EAF9',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        width:'fit-content',
        padding: '4px 8px',
        gap: '10px',
        height: '32px',
    },
    notSelectedTitle:{
        background: '#FFFFFF',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: '4px 8px',
        gap: '10px',
        width:'fit-content',
        height: '32px',
    },
    selectedTitleP:{
        height: '24px',
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '16px',
        lineHeight: '24px',
        width:'fit-content',
        letterSpacing: '-0.0044em',
        color: '#214DCE',
        whiteSpace:'nowrap',
        //width: '190px',

    },
    notSelectedTitleP:{
        height: '24px',
        //width: '190px',
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '16px',
        whiteSpace:'nowrap',
        width:'fit-content',
        lineHeight: '24px',
        letterSpacing: '-0.0044em',
        color: '#272D3C',

    },
    //globalTitle1:{
    //    display: 'flex',
    //    flexDirection: 'row',
    //    alignItems: 'flex-start',
    //    padding: '4px 8px',
    //    gap: '10px',
    //    width: '119px',
    //    height: '32px',
    //    flex: 'none',
    //    order: '0',
    //},

    //globalTitle2:{
    //    display: 'flex',
    //    flexDirection: 'row',
    //    alignItems: 'flex-start',
    //    padding: '4px 8px',
    //    gap: '10px',

    //    width: '20%',
    //    height: '32px',
    //    flex: 'none',
    //    order: '1',
    //}
};

//export const paginationDivStyles =  {
//    display: 'flex',
//    marginTop: '15px',
//    marginBottom: '15px',
//    justifyContent: 'center'
//};
//export const cardStyleAO = {
//    display: 'flex',
//    flexDirection: 'column',
//    alignItems: 'flex-start',
//    padding: '16px',
//    gap: '16px',
//    alignSelf:'stretch',
//    background: '#FFFFFF',
//    border: '2px dashed #9D9E9F',
//    borderRadius: '8px',
//};
